export const OPERATOR_STATUS_TYPES = {
  ALL: 'all',
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
};

export const OPERATOR_AVAILABILITY_TYPES = {
  ALL: 'all',
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
};

export const AUTO_REPLY_TYPES = {
  GENERAL: 'GENERAL-AUTO-REPLY',
  OUT_OF_OFFICE: 'OUT-OF-OFFICE',
  OFFICE_HOURS: 'OFFICE-HOURS',
  AWAY_MESSAGE: 'AWAY-MESSAGE',
};

export default OPERATOR_STATUS_TYPES;
